import React from 'react';
import PropTypes from 'prop-types';

const WardrobeNot = ({ color = '#BCC6CA', lineColor = '#fff', ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24" {...props}>
    <path
      stroke={color}
      strokeLinejoin="round"
      d="M18.651 19.64c0 .927-.597 1.68-1.332 1.68H7.331C6.597 21.32 6 20.566 6 19.64V3.68C6 2.755 6.597 2 7.332 2h9.986c.735 0 1.332.754 1.332 1.68v15.96h.001Z"
      clipRule="evenodd"
    />
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M10.031 11.226v1.858m4.465-1.858v1.858m2.232 8.247V22m0-.669V22m-8.93-.669V22"
    />
    <path stroke={color} strokeLinejoin="round" d="M12.3 2v19.32" />
    <rect
      width={1.5}
      height={28.638}
      x={1.354}
      y={2.414}
      fill={color}
      stroke={lineColor}
      strokeWidth={0.5}
      rx={0.75}
      transform="rotate(-45 1.354 2.414)"
    />
  </svg>
);

WardrobeNot.propTypes = {
  color: PropTypes.string,
  lineColor: PropTypes.string
};

export default WardrobeNot;
